/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import isNil from 'lodash/isNil';
import { injectIntl } from 'react-intl';
import { FormControl } from 'react-bootstrap';
import Select from 'loracoms/Select';
import ControlTips from 'loracoms/ControlTips';
import styles from './styles.scss';

const defaultProps = {
  edit: false,
  control: {},
  formatter: (x) => {
    if (isNil(x)) return x;
    if (React.isValidElement(x)) return x;
    return <span>{x}</span>;
  },
  validator: () => ({ valid: true }),
  visible: true,
  value: null,
  error: null,
  errorPlacement: 'top',
  onChange: () => {},
  data: {},
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  id: React.PropTypes.string.isRequired,
  edit: React.PropTypes.bool.isRequired,
  value: React.PropTypes.any,
  data: React.PropTypes.object,
  onChange: React.PropTypes.func,
  control: React.PropTypes.object,
  error: React.PropTypes.node,
  formatter: React.PropTypes.func,
  errorPlacement: React.PropTypes.string,
};

class Editable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      edit: props.edit,
      data: props.data,
      error: props.error,
      ctrlval: props.data[props.id],
    };
    this.handleChange = this.handleChange.bind(this);
    this.intlMsg = injectIntl(props.intl, '');
  }

  componentWillReceiveProps(nextProps) {
    const {
      id,
      value,
      edit,
      data,
      error,
      control,
    } = nextProps;

    if (value !== this.props.value) {
      this.setState({ value });
    }
    if (edit !== this.props.edit) {
      this.setState({ edit });
    }
    if (data !== this.props.data) {
      this.setState({ data });
      const { formatter = x => x } = control;
      const { ctrlval } = this.state;
      if (formatter(data[id]) !== ctrlval) {
        this.setState({ ctrlval: formatter(data[id]) });
      }
    }
    if (error !== this.props.error) {
      this.setState({ error });
    }
  }

  handleChange(v) {
    const {
      id,
      onChange,
      control: {
        formatter = x => x,
        decoder = x => x,
      },
    } = this.props;
    const ctrlval = formatter(v);
    let { data } = this.state;

    this.setState({ ctrlval });
    data = { ...data, [id]: decoder(ctrlval) };
    onChange(data, id);
  }

  renderControl() {
    const { control } = this.props;
    const { ctrlval } = this.state;
    const { type } = control;

    if (type === 'external') {
      return control.external;
    }

    let ctrl;
    if (type === 'select') {
      ctrl = (
        <Select
          {...control}
          value={ctrlval}
          onChange={v => this.handleChange(v)}
        />
      );
    } else {
      const {
        placeholder,
        className = 'aisz-form-control',
      } = control;
      ctrl = (
        <FormControl
          bsClass={className}
          value={ctrlval}
          placeholder={placeholder}
          onChange={e => this.handleChange(e.target.value)}
        />
      );
    }

    const { error } = this.state;
    const { errorPlacement } = this.props;
    return (
      <div className={styles.editable}>
        {ctrl}
        <ControlTips
          show={!isNil(error)}
          azStyle="danger"
          placement={errorPlacement}
          message={(
            <span>
              <i className="fa fa-exclamation-circle" />
              {' '}
              {error}
            </span>
          )}
        />
      </div>
    );
  }

  render() {
    const { formatter } = this.props;
    const { value, edit } = this.state;
    if (edit) {
      return this.renderControl();
    }
    return formatter(value);
  }
}

Editable.defaultProps = defaultProps;
Editable.propTypes = propTypes;

export default injectIntl(Editable);




// WEBPACK FOOTER //
// ./src/components/Editable/index.jsx